export interface IAccessToken {
    value: string;
    expiration: Date;
    received: Date;
    readonly expiresInSec: number;
    readonly expiresInSecWithMinuteMargin: number;
    readonly expiredSecondAfter: number;
};

export class AccessToken implements IAccessToken {
    value: string;
    expiration: Date;
    received: Date;
    
    constructor(value: string, expiration: Date) {
        this.value = value;
        this.expiration = expiration;
        this.received = new Date();
    }

    get expiresInSec() {
        const expiresInSec = (this.expiration.getTime() - new Date().getTime()) / 1000
        return Math.max(expiresInSec, 0);
    }

    get expiresInSecWithMinuteMargin() {
        return this.expiresInSec - 60;
    }

    get expiredSecondAfter() {
        return this.expiresInSec + 1;
    }
};
